import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
import { slideInDownAnimation } from '../../../app/app.animation';
// Common
import { AngularMaterialService, ErrorParseService, ICompany, LGEDataService } from '../../../commons';
// State
import { Store } from '@ngrx/store';
import * as fromCompany from './state/company.selectors';
import * as CompanyAction from './state/company.actions';
import * as lgeApp from '../../../app/state/app.actions';
import { Observable, Subscription, skipWhile } from 'rxjs';
// import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';


@Component({
    selector: 'company-screen',
    templateUrl: 'company.component.html',
    styleUrls: ['company.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyExtScreenComponent implements OnInit, OnDestroy {
    @Input() pending$: Observable<boolean>;
    pendingSubscription: Subscription;
    pending: boolean;
    @Input() error$: Observable<string | null>;
    errorSubscription: Subscription;
    error: string | null;
    @Input() stateData$: Observable<ICompany | null>;
    stateDataSubscription: Subscription;
    stateData: ICompany | null;

    getData = 'COMPANY';

    companyCCDetails = [];
    companyCIDetails = [];
    companyPPDetails = [];
    isNullCompanyDetails = false;
    isLoadingCompanyDetails = false;
    showErrorCompanyDetails = false;
    errorMessageCompanyDetails: string;

    // @ViewChild(MatPaginator) paginator: MatPaginator;
    // @ViewChild(MatSort) sort: MatSort;

    // displayedColumns = ['code', 'description'];
    // dataSource: MatTableDataSource<any>;

    accDistInfo = {
        'ProjectGroup': {
            'Project': ['']
        },
        'TaskGroup': {
            'Task': ['']
        },
        'CompanyGroup': {
            'Company': ['']
        },
        'ProductGroup': {
            'Product': ['']
        },
        'OrganizationGroup': {
            'Organization': ['']
        },
        'ExpenditureOrgGroup': {
            'ExpenditureOrg': ['']
        },
        'AccountGroup': {
            'Account': ['']
        },
        'IntercompanyGroup': {
            'Intercompany': ['']
        },
        'ExpenditureTypeGroup': {
            'ExpenditureType': ['']
        },
        'LocationGroup': {
            'Location': ['']
        },
        'ReturnType': ''
    }

    // companyData = [
    //     { code: "0000", description: "DEFAULT" },
    //     { code: "0004", description: "LG&E AND KU CAPITAL LLC" },
    //     { code: "0008", description: "LG&E AND KU CAPITAL LLC CONSOLIDATION ELIMINATIONS" },
    //     { code: "0011", description: "LG&E AND KU CAPITAL LLC - PURCHASE ACCTG ADJ" },
    //     { code: "0018", description: "LG&E AND KU SERVICES COMPANY - PURCHASE ACCTG ADJ - FERC ONLY" },
    //     { code: "0019", description: "LG&E AND KU SERVICES COMPANY - GAAP ADJ" }
    // ]

    constructor(
        private store: Store<fromCompany.State>,
        private ref: ChangeDetectorRef,
        private fb: FormBuilder,
        private ams: AngularMaterialService,
        private errorParse: ErrorParseService,
        private _dataService: LGEDataService
    ) {
        this.selectState();
        this.createForms();
        // this.dataSource = new MatTableDataSource([]);
    }


    ngOnInit() {
        this.startSubscriptions();
        this.getActiveCompanyDataCC();
        // this.getActiveCompanyDataCI();
        // this.getActiveCompanyDataPP();
    }

    onTabChange(val) {
        if (val === 1 && this.companyCIDetails.length === 0) {
            this.ams.showLoader('Loading...');
            this.getActiveCompanyDataCI();
        } else if (val === 2 && this.companyPPDetails.length === 0) {
            this.ams.showLoader('Loading...');
            this.getActiveCompanyDataPP();
        }
        // (selectChange)='onSelectChange($event)'  // HTML <mat-tab-group>
        // // console.log(event)
    }

    getActiveCompanyDataCC() {
        this.isLoadingCompanyDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'CC'])
            .subscribe({
                next: data => {
                    if (data) {
                        // this.dataSource = new MatTableDataSource(data);
                        this.companyCCDetails = data;
                        this.isLoadingCompanyDetails = false;
                        // console.log('selected company list');
                        // console.log(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isLoadingCompanyDetails = false;
                        this.isNullCompanyDetails = true;
                        this.errorMessageCompanyDetails = 'There is not any selected company';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingCompanyDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorCompanyDetails = true;
                    this.errorMessageCompanyDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    getActiveCompanyDataCI() {
        this.isLoadingCompanyDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'CI'])
            .subscribe({
                next: data => {
                    if (data) {
                        // this.dataSource = new MatTableDataSource(data);
                        this.companyCIDetails = data;
                        this.isLoadingCompanyDetails = false;
                        // console.log('selected company list');
                        // console.log(data);
                        this.ref.markForCheck();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isLoadingCompanyDetails = false;
                        this.isNullCompanyDetails = true;
                        this.errorMessageCompanyDetails = 'There is not any selected company';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingCompanyDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorCompanyDetails = true;
                    this.errorMessageCompanyDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    getActiveCompanyDataPP() {
        this.isLoadingCompanyDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'PP'])
            .subscribe({
                next: data => {
                    if (data) {
                        // this.dataSource = new MatTableDataSource(data);
                        this.companyPPDetails = data;
                        this.isLoadingCompanyDetails = false;
                        // console.log('selected company list');
                        // console.log(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isLoadingCompanyDetails = false;
                        this.isNullCompanyDetails = true;
                        this.errorMessageCompanyDetails = 'There is not any selected company';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingCompanyDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorCompanyDetails = true;
                    this.errorMessageCompanyDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    editComapnyListCC() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'CC'])
            .subscribe({
                next: data => {
                    // console.log('company list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Company (CC)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected company CC');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'CC'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveCompanyDataCC();
                                            this.ref.markForCheck();
                                        }
                                    }, error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    editComapnyListCI() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'CI'])
            .subscribe({
                next: data => {
                    // console.log('company list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Company (CI)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected company CI');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'CI'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveCompanyDataCI();
                                            this.ref.markForCheck();
                                        }
                                    }, error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                }, error: error => {
                    // console.log(error);
                }
            });
    }

    editComapnyListPFTP() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'PP'])
            .subscribe({
                next: data => {
                    // console.log('company list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Company (Plant for the Planet)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected company PFTP');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'PP'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveCompanyDataPP();
                                            this.ref.markForCheck();
                                        }
                                    }, error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                }, error: error => {
                    // console.log(error);
                }
            });
    }
    // Select state
    selectState(): void {
        this.pending$ = this.store.select(fromCompany.getCompanyScreenPending);
        this.stateData$ = this.store.select(fromCompany.getCompanyState);
        this.error$ = this.store.select(fromCompany.getCompanyScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));
    }

    displayLoader(pending: boolean): void {
        if (pending) {
            this.ams.showLoader("Loading");
        } else {
            this.ams.closeDialog().then(() => {
                if (this.error !== null && this.error !== undefined && this.error !== '') {
                    this.displayError(this.error);
                }
            });
        }
    }

    displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
            errorMessage = this.errorParse.translateCCError(error);
        } else {
            errorMessage = error instanceof Object ? error.message : error;
        }
        this.ams.showAlert("Loading Error", errorMessage);
        this.ams.alert.afterClosed().subscribe(result => {
            this.store.dispatch(new CompanyAction.CompanyScreenErrorReset());
        });
    }

    // Create reactive forms
    createForms(): void {

    }
    // Opens sidenav if on mobile
    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }
    // Subscribe to state data and mark it for changes
    startSubscriptions(): void {
        this.pendingSubscription = this.pending$
            .subscribe(data => {
                this.pending = data;
                this.displayLoader(this.pending);
                this.ref.markForCheck();
            });
        this.errorSubscription = this.error$
            .subscribe(data => {
                this.error = data;
                this.ref.markForCheck();
            });
        this.stateDataSubscription = this.stateData$
            .subscribe(data => {
                this.stateData = data;
                this.ref.markForCheck();
            });
    }
    // Unsubscribe from state data changes
    endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
        this.stateDataSubscription.unsubscribe();
    }

    ngOnDestroy() {
        this.endSubscriptions();
    }


}